<div class="content">
  <div class="header">{{title()}}</div>
  <div class="list">
    <ng-content></ng-content>
  </div>
</div>